module.exports = __webpack_public_path__ + "img/logo_demo.baf6a9f5.svg";